export default __webpack_public_path__ + "static/gilroy-bold-f1e15f534b25e8f4e6ffa8d96092fc9c.woff2";